import React from 'react';
import Table from '../../../common/PDF/Table';
import { splitByThousands, addPercent } from '../../../../helpers/NumberFormatter';
import { find, capitalize } from 'lodash';

const commonKeys = ['name', 'curr_physical_income', 'curr_physical_quantity', 'curr_digital_income', 'curr_digital_quantity', 'curr_nr_income', 'curr_nr_quantity', 'curr_total_income', 'curr_total_quantity'];
const keys = {
    'imprints': [...commonKeys, 'artists', 'projects', 'products', 'tracks'],
    'artists': [...commonKeys],
    'projects': [...commonKeys, 'products'],
    'products': [...commonKeys],
    'tracks': [...commonKeys.filter(key=>!key.startsWith('physical'))],
    
    
}

const titles = [
    { key: 'name', title: 'Imprint',  width: 60, fontSize: 5 },
    { key: 'curr_physical_income', title: 'Physical Income',  width: 20, fontSize: 5, formatFn: splitByThousands },
    { key: 'curr_physical_quantity', title: 'Physical Qty',  width: 20, fontSize: 5, formatFn: splitByThousands },

    { key: 'curr_digital_income', title: 'Digital Income',  width: 20, fontSize: 5, formatFn: splitByThousands },
    { key: 'curr_digital_quantity', title: 'Digital Qty',  width: 20, fontSize: 5, formatFn: splitByThousands },
    { key: 'curr_nr_income', title: 'NR Income', width: 20, fontSize: 5, formatFn: splitByThousands },
    { key: 'curr_nr_quantity', title: 'NR Qty',  width: 20, fontSize: 5, formatFn: splitByThousands },
    { key: 'curr_total_income', title: 'Total Income',  width: 20, fontSize: 5, formatFn: splitByThousands },
    { key: 'curr_total_quantity', title: 'Total Qty',  width: 20, fontSize: 5, formatFn: splitByThousands },

    { key: 'artists', title: 'Artists',  width: 15, fontSize: 5 },
    { key: 'projects', title: 'Projects',  width: 15, fontSize: 5 },
    { key: 'products', title: 'Products',  width: 15, fontSize: 5 },
    { key: 'tracks', title: 'Tracks',  width: 15, fontSize: 5 },
]


export default ({data, entity}) => {
    const singular = (entity || '').replace(/s$/i, '');
    const nameLabel = capitalize(singular || 'Name');

    const dynamicTitles = titles.map(t => t.key === 'name' ? { ...t, title: nameLabel } : t);
    const columns = keys[entity].map(key => find(dynamicTitles, title => title.key == key));
    return <Table items={data} columns={columns} />
}